import './LawyerSection.css'
import React from 'react';

function LawyerSection({ user }) {
    return (
        <section>
            <div className="Lawyer-section">
                {user ? (
                    <>
                        <h1>Bem-vindo de volta!</h1>
                        <h2>Acelere sua produção e ganhe mais tempo. Suas Reclamações Trabalhistas prontas em poucos cliques, com legislação e jurisprudência mais recentes.</h2>
                    </>
                ) : (
                    <>
                        <h1>Crie sua Conta!</h1>
                        <h2>Junte-se à SouJus e simplifique a criação de suas petições iniciais trabalhistas. Clique no botão de login, no canto superior direito, para criar sua conta.</h2>
                    </>
                )}
                <br />
                <img className="imagem_principal" src="/images/img-lawyer2.jpg" alt="Logo do Meu Site" />
            </div>
        </section>
    );
}


export default LawyerSection;